<template>
  <div class="trade-card">
    <div class="tc-header">
      <h3>{{ activeMarket ? activeMarket.title : txt.loading }}</h3>
      <div class="live-badge">LIVE</div>
    </div>

    <div class="tc-tabs">
      <div class="tab" :class="{active: activeTab==='buy'}" @click="activeTab='buy'">{{ txt.buy }}</div>
      <div class="tab" :class="{active: activeTab==='sell'}" @click="activeTab='sell'">{{ txt.sell }}</div>
    </div>

    <div class="tc-outcome-select">
      <div class="outcome-box yes" :class="{selected: selectedOutcome==='yes'}" @click="selectedOutcome='yes'">
        <span class="o-label">{{ txt.yes }}</span>
        <span class="o-price" v-if="activeMarket">Avg {{ txt.price }} {{ activeMarket.prob }}¢</span>
      </div>
      <div class="outcome-box no" :class="{selected: selectedOutcome==='no'}" @click="selectedOutcome='no'">
        <span class="o-label">{{ txt.no }}</span>
        <span class="o-price" v-if="activeMarket">Avg {{ txt.price }} {{ 100 - activeMarket.prob }}¢</span>
      </div>
    </div>

    <div class="tc-input-group">
      <label>{{ txt.amount }} (USDT)</label>
      <input type="number" placeholder="0.00" class="tc-input" v-model="amount" min="0" step="0.01" @input="validateAmount">
      <div class="balance">{{ txt.bal }}: 0.00 USDT</div>
    </div>

    <div class="tc-summary">
      <div class="s-row"><span>{{ txt.est_shares }}</span><span>{{ estShares }}</span></div>
      <div class="s-row"><span>{{ txt.potential_return }}</span><span class="green">+{{ potentialReturn }}%</span></div>
    </div>

    <button class="tc-action-btn" @click="placeOrder">{{ buttonText }}</button>
  </div>
</template>

<script>
import DICT from '../locales/data.js';

export default {
  props: ['activeMarket', 'lang'],
  data() {
    return {
      activeTab: 'buy', // 默认买入
      selectedOutcome: 'yes', // 默认选 YES
      amount: ''
    }
  },
  watch: {
    amount(val) {
      // 移除了重复的验证逻辑，因为 validateAmount 方法已经处理了
    }
  },
  computed: {
    txt() { return DICT[this.lang].trading },
    
    currentPrice() {
      if(!this.activeMarket) return 0.5;
      const prob = this.activeMarket.prob / 100;
      return this.selectedOutcome === 'yes' ? prob : (1 - prob);
    },

    estShares() {
      if(!this.amount || !this.activeMarket || parseFloat(this.amount) <= 0) return '0.00';
      const shares = parseFloat(this.amount) / this.currentPrice;
      return shares.toFixed(2);
    },

    potentialReturn() {
      if(!this.activeMarket) return '0.00';
      // Return % = (1 - Price) / Price * 100
      if (this.currentPrice <= 0) return '0.00';
      const ret = ((1 - this.currentPrice) / this.currentPrice) * 100;
      return ret.toFixed(1);
    },

    // 添加按钮文本
    buttonText() {
      if (!this.amount || parseFloat(this.amount) <= 0) {
        return this.txt.place_order;
      }
      return `${this.txt.place_order} ${this.amount} USDT`;
    }
  },
  methods: {
    validateAmount() {
      if (this.amount === '' || this.amount === null) return;
      let num = parseFloat(this.amount);
      if (isNaN(num)) {
        this.amount = '';
        return;
      }
      if (num < 0) {
        this.amount = 0;
      } else if (num > 1000000) {
        this.amount = 1000000;
      } else {
        // 保留两位小数
        this.amount = Math.round(num * 100) / 100;
      }
    },

    placeOrder() {
      if (!this.amount || parseFloat(this.amount) <= 0) {
        alert(this.txt.error_amount);
        return;
      }

      if (!this.activeMarket) {
        alert(this.txt.error_market);
        return;
      }

      // 模拟下单逻辑
      const order = {
        market: this.activeMarket.title,
        outcome: this.selectedOutcome,
        amount: parseFloat(this.amount),
        price: this.currentPrice,
        shares: parseFloat(this.estShares),
        type: this.activeTab,
        timestamp: new Date().toISOString()
      };

      console.log('Placing order:', order);
      
      // 这里应该调用实际的区块链交易
      alert(`${this.txt.order_placed}: ${this.amount} USDT for ${this.selectedOutcome === 'yes' ? this.txt.yes : this.txt.no} outcome`);
      
      // 重置表单
      this.amount = '';
    }
  }
}
</script>

<style scoped>
.trade-card { background: #1a1b20; border: 1px solid #333; border-radius: 16px; padding: 24px; max-width: 480px; width: 100%; box-shadow: 0 20px 60px rgba(0,0,0,0.5); }
.tc-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 20px; }
.tc-header h3 { margin: 0; font-size: 18px; color: #fff; max-width: 80%; line-height: 1.4; }
.live-badge { background: #00D092; color: #000; font-size: 10px; padding: 2px 6px; border-radius: 4px; font-weight: 800; }
.tc-tabs { display: flex; background: #111; padding: 4px; border-radius: 8px; margin-bottom: 20px; }
.tab { flex: 1; text-align: center; padding: 8px; font-size: 13px; cursor: pointer; color: #666; border-radius: 6px; transition: 0.2s; }
.tab:hover { color: #fff; }
.tab.active { background: #333; color: #fff; font-weight: bold; }
.tc-outcome-select { display: flex; gap: 10px; margin-bottom: 20px; }
.outcome-box { flex: 1; border: 1px solid #333; padding: 15px; border-radius: 10px; cursor: pointer; text-align: center; transition: 0.2s; }
.outcome-box:hover { border-color: #555; }
.outcome-box.selected.yes { border-color: #00D092; background: rgba(0,208,146,0.1); }
.outcome-box.selected.no { border-color: #ff5e57; background: rgba(255,94,87,0.1); }
.o-label { display: block; font-weight: 700; color: #fff; margin-bottom: 5px; }
.o-price { font-size: 11px; color: #888; }
.tc-input-group { margin-bottom: 20px; }
.tc-input-group label { display: block; font-size: 12px; color: #888; margin-bottom: 8px; }
.tc-input { width: 100%; background: #111; border: 1px solid #333; padding: 12px; border-radius: 8px; color: #fff; font-size: 16px; outline: none; }
.tc-input:focus { border-color: #00D092; }
.balance { text-align: right; font-size: 11px; color: #666; margin-top: 6px; }
.tc-summary { background: #222; padding: 15px; border-radius: 8px; margin-bottom: 20px; }
.s-row { display: flex; justify-content: space-between; font-size: 13px; color: #ccc; margin-bottom: 5px; }
.s-row:last-child { margin-bottom: 0; }
.green { color: #00D092; }
.tc-action-btn { width: 100%; background: #00D092; border: none; padding: 14px; border-radius: 10px; font-weight: 800; font-size: 15px; cursor: pointer; color: #000; transition: 0.2s; }
.tc-action-btn:hover { opacity: 0.9; transform: scale(1.02); }
</style>